import React, { Fragment } from "react";
import RadioButtons from "../../RadioButtons";

const receivedOptions = [
  { label: "Show All", value: "all" },
  { label: "Not Received", value: "not_received" },
  { label: "Received", value: "received" }
];

export default function ReceivedStatus({ onChange, value }) {
  return (
    <Fragment>
      <label>{I18n.t("received_status")}</label>
      <br />
      <RadioButtons
        name="received"
        onChange={dropDownItem => onChange(dropDownItem.value)}
        options={receivedOptions}
        value={value}
      />
    </Fragment>
  );
}
